import clsx from 'clsx';
import api from 'services/api';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { InputLabel, Select } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: 42,
    display: 'flex',
    alignItems: 'left',
    marginTop: theme.spacing(1)
  },
  spacer: { flexGrow: 10 },
  margin: { marginLeft: theme.spacing(2) }
}));

/* Combo de seleção da empresa ativa (sessão) */
const ComboEmpresa = props => {
  const { className } = props;
  const classes = useStyles();

  const [empresas, setEmpresas] = useState({ companies: [] });

  const [selectedEmpresa, setSelectedEmpresa] = useState(
    parseInt(sessionStorage.getItem('codEmpresa'), 10) || ''
  );

  const isMountedRef = useRef(false);

  // atualiza a empresa selecionada e persiste na sessão
  const handleChangeEmpresa = event => {
    const value = event.target.value;

    setSelectedEmpresa(value);

    sessionStorage.setItem('codEmpresa', value);
  };

  // carrega a lista de empresas disponíveis
  useEffect(() => {
    isMountedRef.current = true;

    async function loadEmpresas() {
      try {
        const response = await api.get('/empresa');

        if (isMountedRef.current) {
          setEmpresas({ companies: response.data });
        }
      } catch (error) {
        console.log(error);
      }
    }

    loadEmpresas();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const listEmpresas = empresas.companies.map((empresa) => (
    <option
      key={empresa.codigo}
      value={empresa.codigo}
    >
      {empresa.fantasia}
    </option>
  ));

  return (
    <div className={clsx(
      classes.root,
      className
    )}>
      <InputLabel
        htmlFor="outlined-age-native-simple"
        style={{ display: (listEmpresas.length > 1 ? '' : 'none') }}
      >
        Empresa
      </InputLabel>

      <Select
        fullWidth
        inputProps={{
          id: 'outlined-age-native-simple',
          name: 'cmbEmpresa'
        }}
        label="nomeempresa"
        native
        onChange={handleChangeEmpresa}
        style={{ display: (listEmpresas.length > 1 ? '' : 'none') }}
        value={selectedEmpresa}
      >
        {listEmpresas}
      </Select>
    </div>
  );
};

ComboEmpresa.propTypes = {
  className: PropTypes.string
};

export default ComboEmpresa;